export function getFeedbackTooltipStyle(isDarkMode) {
  return isDarkMode
    ? {
        backgroundColor: "#1f2937",
        border: "1px solid #374151",
        borderRadius: 8,
        color: "#e5e7eb",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.22)",
      }
    : {
        backgroundColor: "#f3f4f6",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        color: "#111827",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
      };
}

export function getFeedbackBarCursor(isDarkMode) {
  return {
    fill: isDarkMode ? "rgba(148, 163, 184, 0.1)" : "rgba(71, 85, 105, 0.07)",
  };
}

export function getFeedbackLineCursor(isDarkMode) {
  return {
    stroke: isDarkMode ? "#4b5563" : "#cbd5e1",
    strokeWidth: 1,
  };
}

export function getFeedbackActiveBar(isDarkMode) {
  return {
    fill: isDarkMode ? "rgba(148, 163, 184, 0.22)" : "rgba(71, 85, 105, 0.14)",
  };
}

export function getFeedbackStatCardClassName(isDarkMode) {
  return isDarkMode
    ? "border-gray-700 bg-gray-800/80 hover:bg-gray-700/45"
    : "border-gray-200 bg-white hover:bg-slate-50/90";
}
